export default class Blog{
	id:string;
	title:string;
	text:string;
	text_en:string;
	image:any;
	date:any;
}